import { useAppSelector } from 'store/hooks';
import { selectUserInfo } from 'store/slices/userInfoSlice';
import { getShopConfig } from 'constant/shop';

const CurrentShop = () => {
  const { shop } = useAppSelector(selectUserInfo);

  if (!shop) return null;

  return <span>{getShopConfig(shop).label}</span>;
};

export default CurrentShop;
